module.exports = __webpack_public_path__ + "img/sax-aperitivo.24936fed.jpg";